import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      “A veces los niños de la tierra, y también las gentes mayores, sienten deseos de volver a Lilac y recuerdan algo
      de lo que allí vieron. Entonces hay una manera de volver a ese hermoso país, pero nunca se llega completamente; lo
      vemos de lejos, como entre niebla, como entre cristales opacos. Este camino para volver a Lilac se llama la
      Imaginación, y es conveniente andarlo de vez en cuando”.
    </p>
    <p className="content justified">
      Lilac es un país parecido a Liliput, nos dice Díaz Díaz. Su principal característica es que allí no hay gente
      grande, sino que todos son niños y ellos mismos se gobiernan. Como no hay adultos, los pequeños no sufren con la
      ropa nueva y apretada que ellos les comprarían, ni con el ridículo de usar sombreros.
    </p>
    <p className="content justified">
      En este maravilloso lugar no existen las enfermedades, así que no hay farmacias ni odontólogos; tampoco existe el
      Coco, ni ningún otro invento aterrador para asustar a los niños.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Sus fronteras colindan con El País de Todo es Posible por el sur, El País de Nunca Sufrir al oeste, El País de
      Empezar a Vivir hacia el occidente y El país de Nunca y Adiós por el norte. “En Lilac casi todo el tiempo se vive
      al aire libre, no se le tiene miedo al sol ni al aire y los niños están en continuo trato con el agua, con las
      flores y con los animales”.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">El reino de los niños</h3>
      <p className="content justified">
        Lilac es entonces una especie de reino de la infancia, donde los niños viven felices, en libertad, donde los
        letreros en las vitrinas son “Ver y tocar” o “Ver y probar”. Es un país soñado para los niños, que nos recuerda
        al País de Nunca Jamás de <i>Peter Pan</i>, no solo por la ausencia de adultos, sino por las amplias
        posibilidades de diversión y de vida que tienen los más jóvenes.
      </p>
      <p className="content justified">
        Además, en Lilac, los niños aman la escuela, ya que “Allí un día los chiquillos quieren conocer algo sobre las
        flores, y entonces en el patio de la escuela brotan hermosas rosas y violetas y caléndulas y claveles y geranios
        y cuantas flores deseen los niños; y las ven crecer y ven cómo desde una semillita nace la planta, y cómo ésta
        echa raíces, y cómo le brotan las hojas y cómo le cuajan las flores”.
      </p>
      <p className="content justified">
        Así que la escuela es un espacio de aprendizaje vivencial, al aire libre, con posibilidades para la imaginación,
        la curiosidad, donde no hay miedo de ensuciarse. Allí también existen libros para los niños, que no son los
        mismos libros grandes y aburridos de los adultos, sino que están llenos de ilustraciones y tienen la letra
        grande.
      </p>
      <p className="content justified">
        Por todo lo anterior, Lilac es el lugar de la infancia por excelencia, donde un adulto o un niño de más de 10
        años que ya ha cruzado El País de Nunca y Adiós puede volver con la imaginación.
      </p>
    </div>
    <div className="sectionReview">
      <h3 className="review-title subtitle">Lilac: el lugar de Don Os</h3>
      <p className="content justified">
        Lilac es un lugar insignia para hablar de Oswaldo Díaz Díaz. Aparece en este relato, que fue publicado por
        primera vez en una antología de cuentos que lleva el mismo nombre. Posteriormente apareció en{" "}
        <i>Retorno a Lilac</i> y <i>Otra vez en Lilac</i>.
      </p>
      <p className="content justified">
        Pero Lilac no es solo un asunto de nombres o títulos, es realmente una concepción de infancia, un mundo para
        niños donde las reglas son diferentes a las de los adultos, la lógica cambia, los niños tienen criterio y
        capacidad de decisión, y donde el aprendizaje es experiencial y divertido, mediado por la interacción y no solo
        por la teoría.
      </p>
      <p className="content justified">
        Lilac y sus niños son merecedores de libros y literatura escrita especialmente para ellos. Oswaldo Díaz Díaz
        eligió escribir para los niños y cada vez que lo hizo, Don Os volvió a Lilac.
      </p>
    </div>
  </div>
);
